<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="toc">
<h2 class="contentsHead">Contents</h2>
<p class="contentsEntry"><a href="#/WingedVictory_dedication#dedication">To Henry Williamson</a></p>
<p class="contentsEntry"><a href="#/WingedVictory_phase1#phase1">Phase One</a></p>
<p class="contentsEntry"><span href="#/WingedVictory_phase2#phase2" title="Link target outside of Sample">Phase Two</span></p>
<p class="contentsEntry"><span href="#/WingedVictory_phase3#phase3" title="Link target outside of Sample">Phase Three</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// WingedVictory_toc.vue?35aac845